// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"732":"31d6cfe0","916":"ef5d939c"}[chunkId] + ".chunk.css";
};